import { Navigate, Outlet, useLocation } from "react-router";
import { useSelector } from "react-redux";
import { selectCurrentToken, selectCurrentUser } from "../../api/auth/authSlice";

interface Props {
    allowedRoles: string[];
}

export function RequireAuth({ allowedRoles }: Props) {
    const token = useSelector(selectCurrentToken);
    const user = useSelector(selectCurrentUser);
    const location = useLocation();

    return (
        allowedRoles.find(role => user?.role === role)
        ? <Outlet />
        : 
        token
            ? <Navigate to="/not-found" state={{ from: location }} replace />
            : <Navigate to={"/login"} state={{ from: location }} replace />
    );
}